import TakePhotoIcon from 'assets/ver2/icons/take-photo-icon.svg';
import styled from 'styled-components';
import {
  cursorPointerMixin,
  displayFlexColCenterCenterMixin,
  paragraph500Mixin,
} from 'styles';

const FormInputUploadDocumentsFileTakePhotoMask = ({ name, label }) => {
  const renderTakePhotoDesc = () => {
    if (!label) return null;
    return (
      <>
        <TakePhotoDesc htmlFor={name}>{label}</TakePhotoDesc>
      </>
    );
  };

  return (
    <FormInputUploadDocumentsFileTakePhotoMaskStyled>
      <TakePhotoImage src={TakePhotoIcon} />
      {renderTakePhotoDesc()}
    </FormInputUploadDocumentsFileTakePhotoMaskStyled>
  );
};

const FormInputUploadDocumentsFileTakePhotoMaskStyled = styled.div`
  position: absolute;
  ${displayFlexColCenterCenterMixin};
  gap: 10px;
  width: 100%;
  height: 100%;
  ${cursorPointerMixin};
`;

const TakePhotoImage = styled.img`
  width: 30px;
  height: 30px;
  ${cursorPointerMixin};
`;
const TakePhotoDesc = styled.p`
  ${paragraph500Mixin};
  text-align: center;
  ${cursorPointerMixin};
`;

export default FormInputUploadDocumentsFileTakePhotoMask;
